<nz-header class="table-header">
  <div class="table-header-row margin-lr">
    <div class="table-header-cell">
      {{ "Fugl-Meyer Assessment" | translate }}
    </div>
  </div>
</nz-header>

@if (!isLoading && pages.length > current) {
  <form
    style="margin-bottom: 10em"
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
  >
    <!-- Always horizontal: the pages are long and two-column, too wide to
         sit inside a vertical step's description. -->
    <nz-steps
      [nzCurrent]="current"
      [nzProgressDot]="progressTemplate"
      (nzIndexChange)="onIndexChange($event)"
    >
      @for (page of pages; track page; let i = $index) {
        <nz-step
          [nzTitle]="getPageTitle(page)"
          [nzDisabled]="disable && i > current"
        />
      }
    </nz-steps>

    <ng-template
      #progressTemplate
      let-dot
      let-status="status"
      let-index="index"
    >
      <span nz-popover>
        <ng-template [ngTemplateOutlet]="dot"></ng-template>
      </span>
    </ng-template>

    <app-fugl-meyer-questions
      [elements]="pages[current].elements"
      [allElements]="allElements"
      [pageTitle]="pages[current].title"
      [formGroup]="formGroup"
      [readonlyMode]="readonlyMode"
    />


    <div class="steps-action">
      <div class="left-actions">
        <button
          nz-button
          nzType="default"
          (click)="pre($event)"
          [disabled]="!(current > 0)"
          class="previous"
        >
          <span>{{ "Previous" | translate }}</span>
        </button>
        <button
          nz-button
          nzType="default"
          (click)="next($event)"
          [disabled]="!(current < pages.length - 1)"
        >
          <span>{{ "Next" | translate }}</span>
        </button>
      </div>
      <div class="right-actions" *hasAddPermissions="['a-sqa']">
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzDanger
            class="cancel-btn"
            type="button"
            (click)="revertForm()"
            [disabled]="!hasChanges"
          >
            <span>{{ "Revert" | translate }}</span>
          </button>
        }
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzType="primary"
            type="submit"
            [disabled]="!hasChanges"
          >
            <span>{{ "Submit" | translate }}</span>
          </button>
        }
      </div>
    </div>
  </form>
}

@if (isLoading) {
  <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
}
